import { Split } from '@dropbox/dig-foundations';
import React from 'react';
import { ContinueButton } from '../action-buttons/continue-button';
import { FieldCountIndicator } from './field-count-indicator';
import { useShouldShowDrawer } from 'signer-app/utils/use-should-show-drawer';
import { SignStepToolbarLayout } from './sign-step-toolbar-layout';
import { AccessibleDocumentToggle } from 'signer-app/signer-signature-document/accessible-document-toggle';
import { useSignerContext } from '../signer-experience';

interface Props {
  toolbarMenu: React.ReactNode;
  requiredFieldsLeft: number;
}

export function FormViewToolbar({ toolbarMenu, requiredFieldsLeft }: Props) {
  const shouldShowDrawer = useShouldShowDrawer();
  const { hideFormViewToggle } = useSignerContext();

  return (
    <SignStepToolbarLayout>
      <Split gap="Micro Small" alignY="center">
        <Split.Item>{toolbarMenu}</Split.Item>
        {!hideFormViewToggle && (
          <Split.Item>
            <AccessibleDocumentToggle />
          </Split.Item>
        )}
      </Split>

      <Split
        gap={{
          small: 'Micro Large',
          xsmall: 'Micro Small',
        }}
        alignY="center"
      >
        {/* don't show the field count indicator on small screen */}
        {!shouldShowDrawer && (
          <Split.Item>
            <FieldCountIndicator requiredFieldsLeft={requiredFieldsLeft} />
          </Split.Item>
        )}
        <Split.Item>
          <ContinueButton />
        </Split.Item>
      </Split>
    </SignStepToolbarLayout>
  );
}
